var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35398 13.6134H4.14065C2.03398 13.6134 1.33398 12.2134 1.33398 10.8067V5.19339C1.33398 3.08672 2.03398 2.38672 4.14065 2.38672H8.35398C10.4607 2.38672 11.1607 3.08672 11.1607 5.19339V10.8067C11.1607 12.9134 10.454 13.6134 8.35398 13.6134Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0135 11.4001L11.1602 10.1001V5.89342L13.0135 4.59342C13.9202 3.96009 14.6668 4.34675 14.6668 5.46009V10.5401C14.6668 11.6534 13.9202 12.0401 13.0135 11.4001Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66797 7.33398C8.22025 7.33398 8.66797 6.88627 8.66797 6.33398C8.66797 5.7817 8.22025 5.33398 7.66797 5.33398C7.11568 5.33398 6.66797 5.7817 6.66797 6.33398C6.66797 6.88627 7.11568 7.33398 7.66797 7.33398Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/VideoCall.de75b3bd7c2d122da1a4575fceaeff1a.svg";
export { ForwardRef as ReactComponent };